// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Button_buttonContainer__0MWME","disabled":"Button_disabled__DkgJ+","spinner":"Button_spinner__ZUyM0"};